(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["omega-map"] && !Shopify.designMode) return;
  try {
    
(function(){
  // ── Canonical omega values (mg per 100 g edible portion) ──────────────
  // Source: seatopianutritionresolved.csv, last updated June 2, 2026.
  // src "Edacious" = mean of n third-party samples; "Light Labs" = single-sample fallback.
  const P=[
    {s:"Steelhead Trout",   f:"Hudson Valley",     oz:6,    src:"Edacious",  n:3, e:332, d:919,  a:1430},
    {s:"King Salmon",       f:"Ora King",          oz:7.5,  src:"Edacious",  n:2, e:474, d:951,  a:1072},
    {s:"King Salmon",       f:"Mt Cook",           oz:7,    src:"Edacious",  n:2, e:404, d:763,  a:1010},
    {s:"Atlantic Salmon",   f:"Bakkafrost",        oz:6,    src:"Edacious",  n:6, e:417, d:738,  a:840},
    {s:"Steelhead Trout",   f:"Caleta Bay",        oz:6,    src:"Edacious",  n:3, e:231, d:521,  a:1173},
    {s:"King Salmon",       f:"Regal",             oz:7.5,  src:"Light Labs",n:1, e:276, d:750,  a:999},
    {s:"Osetra Caviar",     f:"Marshallberg",      oz:0.25, src:"Edacious",  n:3, e:434, d:1042, a:158},
    {s:"Branzino",          f:"Esteros Lubimar",   oz:6,    src:"Edacious",  n:6, e:269, d:529,  a:779},
    {s:"Sea Bream",         f:"Esteros Lubimar",   oz:6,    src:"Edacious",  n:6, e:196, d:502,  a:569},
    {s:"Salmon Roe Caviar", f:"Yarra Valley",      oz:0.25, src:"Edacious",  n:3, e:447, d:1306, a:135},
    {s:"Rainbow Trout",     f:"McFarland Springs", oz:6,    src:"Edacious",  n:6, e:241, d:591,  a:1127},
    {s:"Yellowtail",        f:"The Kingfish Co.",  oz:8,    src:"Edacious",  n:3, e:165, d:483,  a:138},
    {s:"Rainbow Trout",     f:"Smoke in Chimneys", oz:6,    src:"Light Labs",n:1, e:86,  d:404,  a:33},
    {s:"Barramundi",        f:"Australis",         oz:6,    src:"Edacious",  n:3, e:27,  d:82,   a:29},
    {s:"Black Tiger Shrimp",f:"Tarakan",           oz:4,    src:"Edacious",  n:3, e:17,  d:20,   a:8},
    {s:"Peruvian Scallops", f:"Seacorp",           oz:2,    src:"Edacious",  n:3, e:60,  d:41,   a:3}
  ];

  const OZ_TO_G=28.3495;

  // ── Microplastics (Light Labs / EMSL) ────────────────────────────────
  // 6-polymer FTIR panel, LOD = 1 microparticle. All tested products read ND
  // (0 of 6 polymers detected). Per-polymer source: microplasticsreference.csv
  // (last updated June 2, 2026). COA PDF links + test dates from the master sheet.
  const MP_PANEL = {
    lod: 1, unit: 'microparticles',
    lab: 'EMSL Analytical (via Light Labs)', method: 'FTIR / optical microscopy',
    polymers: [
      {a:'HDPE', n:'High-Density Polyethylene',  s:'milk jugs, bottle caps'},
      {a:'LDPE', n:'Low-Density Polyethylene',   s:'plastic bags, films'},
      {a:'PET',  n:'Polyethylene Terephthalate', s:'water bottles, fishing line'},
      {a:'PP',   n:'Polypropylene',              s:'caps, ropes, fishing nets'},
      {a:'PS',   n:'Polystyrene',                s:'foam packaging, pen floats'},
      {a:'PVC',  n:'Polyvinyl Chloride',         s:'pipes, liners'}
    ]
  };
  // r: result ('ND'); code: Light Labs test #; coa: published COA PDF URL;
  // date: microplastics test date (ISO); note: caveat shown in tooltip.
  const MP_BY_FARM = {
    "Hudson Valley":     {r:'ND', code:'21516', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Hudson_Valley-Steelhead_Trout-Lot_2352361.pdf?v=1783783882', lot:'2352361'},
    "Ora King":          {r:'ND', code:'21518', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/Seatopia___Ora_King___King_Salmon_Seatopia___Ora_King___King_Salmon_-_Lot_5668_-_COA.pdf?v=1783709287', lot:'5668'},
    "Mt Cook":           {r:'ND', code:'21517', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/Seatopia___Mt._Cook___Alpine_King_Salmon_Seatopia___Mt._Cook___Alpine_King_Salmon_-_Lot_730924_-_COA.pdf?v=1783707143', lot:'730924'},
    "Bakkafrost":        {r:'ND', code:'21521', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/Seatopia___Bakkafrost___Atlantic_Salmon_Seatopia___Bakkafrost___Atlantic_Salmon_-_Lot_4467_-_COA.pdf?v=1783721092', lot:'4467'},
    "Caleta Bay":        {r:'ND', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/EMSL_CaletaBay_110625.pdf?v=1783722341', date:'2025-11-06', note:'Per-polymer detail is on the linked EMSL COA (not in the resolved microplastics reference).'},
    "Regal":             {r:'ND', code:'21524'},
    "Marshallberg":      {r:'ND', code:'22503'},
    "Esteros Lubimar":   {r:'ND', code:'21525/21526'},
    "Yarra Valley":      {r:'ND', code:'21527', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Yarra_Valley-Salmon_Roe_Caviar-Lot_1965.pdf?v=1783790527', lot:'1965'},
    "McFarland Springs": {r:'ND', code:'22135', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/Seatopia___McFarland_Springs___Rainbow_Trout_McFarland_Springs_Trout_Dogs_-_-_COA.pdf?v=1783790934', note:'Microplastics panel was run on the McFarland Springs Trout Dogs variant, not the rainbow-trout fillet.'},
    "The Kingfish Co.":  {r:'ND', code:'21520', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Kingfish_Co-Yellowtail-Lot_3089.pdf?v=1783790169', lot:'3089'},
    "Smoke in Chimneys": {r:'ND', code:'21519', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Smoke_in_Chimneys-Rainbow_Trout-Lot_RBT0001.pdf?v=1783789920', lot:'RBT0001'},
    "Australis":         {r:'ND', code:'21514', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Australis-Barramundi-Lot_83142422204.pdf?v=1783785720', lot:'83142422204'},
    "Tarakan":           {r:'ND', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/Tarakan_Monodan_ShellOff.pdf?v=1783784622'},
    "Seacorp":           {r:'ND', code:'21523', coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Seacorp-Peruvian_Scallops-Lot_935.pdf?v=1783786078', lot:'935'}
    // Marshallberg + Regal: tested (test # above) but no published COA link on the master sheet yet.
  };
  // Per-product COA overrides — same farm, different lot/COA per species:
  const MP_BY_PRODUCT = {
    "Branzino|Esteros Lubimar":  {coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Esteros_Lubimar-Branzino-Lot_BZ_EST_0001.pdf?v=1783785282', lot:'BZ_EST_0001'},
    "Sea Bream|Esteros Lubimar": {coa:'https://cdn.shopify.com/s/files/1/0222/9882/0682/files/MP-Esteros_Lubimar-Sea_Bream-Lot_BR0001.pdf?v=1783785488', lot:'BR0001'}
  };
  P.forEach(p => {
    const base = MP_BY_FARM[p.f], ov = MP_BY_PRODUCT[p.s+'|'+p.f];
    if (base || ov) {
      const m = Object.assign({}, base||{}, ov||{});
      p.mp=m.r; p.mpCode=m.code||''; p.mpCoa=m.coa||''; p.mpDate=m.date||''; p.mpLot=m.lot||''; p.mpNote=m.note||'';
    }
  });

  const MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fmtDate(iso){ if(!iso) return ''; const d=new Date(iso+'T00:00:00'); return MONTHS[d.getMonth()]+' '+d.getDate()+', '+d.getFullYear(); }

  let basis='serving', openIdx=-1, view='chart', sortK='total', sortA=false;

  // Scale a per-100g value to the current basis
  function sc(v100,oz){ return basis==='100g' ? v100 : Math.round(v100*oz*OZ_TO_G/100); }
  function gs(p){const e=sc(p.e,p.oz),d=sc(p.d,p.oz),a=sc(p.a,p.oz);return{e:e,d:d,a:a,t:e+d+a};}
  function basisLabel(p){return basis==='100g'?'mg / 100 g':'mg / '+p.oz+' oz';}

  function renderChart(){
    const sorted=[...P].sort((a,b)=>gs(b).t-gs(a).t);
    const mx=Math.max(...sorted.map(p=>gs(p).t));

    let h='';
    sorted.forEach((p,i)=>{
      const d=gs(p);
      const bw=mx>0?(d.t/mx)*68:0;
      const ep=d.t>0?(d.e/d.t*100):0;
      const dp=d.t>0?(d.d/d.t*100):0;
      const ap=Math.max(0,100-ep-dp);
      const eL=ep>12?'<span class="om-sl">EPA '+d.e.toLocaleString()+'</span>':'';
      const dL=dp>14?'<span class="om-sl">DHA '+d.d.toLocaleString()+'</span>':'';
      const aL=ap>14?'<span class="om-sl">ALA '+d.a.toLocaleString()+'</span>':'';
      const servInfo=basis==='100g'?'per 100 g':p.oz+' oz serving';

      const mpBadge = p.mp
        ? '<span style="display:inline-block;background:#1D3D3E;color:#fff;font-size:9px;font-weight:700;padding:1px 5px;border-radius:3px;margin-left:6px;letter-spacing:0.3px" title="0 of 6 polymers detected &middot; LOD 1 microparticle &middot; EMSL FTIR">0 / 6 MP</span>'
        : '';

      h+='<div class="om-row" onclick="omDet('+i+')">'
        +'<div class="om-lbl"><div class="om-sp">'+p.s+', '+p.f+mpBadge+'</div><div class="om-fm">'+servInfo+' &middot; '+p.src+'</div></div>'
        +'<div class="om-bw"><div class="om-bar" style="width:'+bw+'%">'
        +'<div class="om-bar-epa" style="width:'+ep+'%">'+eL+'</div>'
        +'<div class="om-bar-dha" style="width:'+dp+'%">'+dL+'</div>'
        +'<div class="om-bar-ala" style="width:'+ap+'%">'+aL+'</div>'
        +'</div><div class="om-val">'+d.t.toLocaleString()+' mg</div></div>'
        +'<div class="om-ts"><strong>'+p.n+'</strong>sample'+(p.n>1?'s':'')+'</div></div>';

      const ul=basisLabel(p);
      const polyChips = MP_PANEL.polymers.map(pp =>
        '<span style="display:inline-block;background:#fff;border:1px solid rgba(29,61,62,0.3);border-radius:3px;padding:1px 5px;margin:1px 3px 1px 0;font-size:10px" title="'+pp.n+' — '+pp.s+'"><strong style="color:#1D3D3E">'+pp.a+'</strong> <span style="color:#1D3D3E;font-weight:700">ND</span></span>'
      ).join('');
      let mpMeta='EMSL FTIR / optical microscopy';
      if(p.mpCode) mpMeta+=' &middot; Test #'+p.mpCode;
      if(p.mpDate) mpMeta+=' &middot; Tested '+fmtDate(p.mpDate);
      else if(p.mpLot) mpMeta+=' &middot; Lot '+p.mpLot;
      mpMeta+=' &middot; Light Labs';
      const coaLink = p.mpCoa ? ' &middot; <a class="om-mp-link" href="'+p.mpCoa+'" target="_blank" rel="noopener">View Certificate of Analysis (PDF)</a>' : '';
      const noteLine = p.mpNote ? '<div style="font-size:10px;color:#6B8588;font-style:italic;margin-top:3px">'+p.mpNote+'</div>' : '';
      const mpLine = p.mp
        ? '<div style="margin-top:8px;padding:10px 12px;background:rgba(29,61,62,0.06);border-left:3px solid #1D3D3E;border-radius:4px;font-size:11px;color:#1D3D3E">'
          +'<div style="font-weight:700;margin-bottom:3px">Microplastics: 0 microparticles detected <span style="font-weight:400;color:#555">&middot; 0 of 6 polymers &middot; LOD 1 microparticle</span></div>'
          +'<div style="margin:4px 0">'+polyChips+'</div>'
          +'<div style="font-size:10px;color:#555">'+mpMeta+coaLink+'</div>'
          +noteLine
          +'</div>'
        : '<div style="margin-top:8px;padding:8px 12px;background:rgba(0,0,0,0.03);border-left:3px solid #CDD9D1;border-radius:4px;font-size:11px;color:#6B8588;font-style:italic">Microplastics screening not yet on file for this farm.</div>';
      h+='<div class="om-det" id="om-d-'+i+'"><div class="om-det-g">'
        +'<div class="om-det-b"><div class="lb epa">EPA</div><div class="nm">'+d.e.toLocaleString()+'</div><div class="un">'+ul+'</div></div>'
        +'<div class="om-det-b"><div class="lb dha">DHA</div><div class="nm">'+d.d.toLocaleString()+'</div><div class="un">'+ul+'</div></div>'
        +'<div class="om-det-b"><div class="lb ala">ALA</div><div class="nm">'+d.a.toLocaleString()+'</div><div class="un">'+ul+'</div></div>'
        +'</div><div class="om-det-m">Marine omega (EPA + DHA): <strong>'+(d.e+d.d).toLocaleString()+' '+ul.replace('mg ','mg')+'</strong> &middot; '+p.n+' sample'+(p.n>1?'s':'')+' &middot; '+p.f+' &middot; '+servInfo+' &middot; '+p.src+'</div>'+mpLine+'</div>';
    });
    document.getElementById('om-chart').innerHTML=h;
  }

  function renderTable(){
    let rows=[];
    P.forEach(p=>{
      rows.push({s:p.s,f:p.f,src:p.src,oz:p.oz,assay:'Fatty Acids',n:p.n,
        e:sc(p.e,p.oz),d:sc(p.d,p.oz),a:sc(p.a,p.oz),t:sc(p.e,p.oz)+sc(p.d,p.oz)+sc(p.a,p.oz),mp:null,coa:'',date:''});
      if (p.mp) rows.push({s:p.s,f:p.f,src:'Light Labs (EMSL)',oz:p.oz,assay:'Microplastics',n:'',
        e:null,d:null,a:null,t:null,mp:p.mp,coa:p.mpCoa,date:p.mpDate});
    });
    rows.sort((a,b)=>{let va=a[sortK],vb=b[sortK];if(va==null)va=-Infinity;if(vb==null)vb=-Infinity;if(typeof va==='string'){va=va.toLowerCase();vb=vb.toLowerCase();}return sortA?(va<vb?-1:va>vb?1:0):(va>vb?-1:va<vb?1:0);});

    const uLbl=basis==='100g'?' (mg/100 g)':' (mg/serving)';
    let h='<div class="om-tbl-wrap"><table class="om-tbl"><thead><tr>';
    [{k:'s',l:'Species'},{k:'f',l:'Farm'},{k:'src',l:'Lab / Source'},{k:'assay',l:'Assay'},{k:'n',l:'n'},{k:'oz',l:'Serving'},{k:'e',l:'EPA'+uLbl},{k:'d',l:'DHA'+uLbl},{k:'a',l:'ALA'+uLbl},{k:'t',l:'Total'+uLbl},{k:'mp',l:'MP (COA)'}].forEach(c=>{
      h+='<th onclick="omSort(\''+c.k+'\')">'+c.l+(sortK===c.k?(sortA?' ▲':' ▼'):' ⇅')+'</th>';
    });
    h+='</tr></thead><tbody>';
    const fmtCell=v=>v==null?'<span style="color:#bbb">&mdash;</span>':v.toLocaleString();
    rows.forEach(r=>{
      const servTxt=basis==='100g'?'100 g':r.oz+' oz';
      const isMP=r.assay==='Microplastics';
      let mpCell='<span style="color:#bbb">&mdash;</span>';
      if(r.mp){
        const label='0 / 6'+(r.date?' &middot; '+fmtDate(r.date):'');
        mpCell = r.coa
          ? '<a class="om-mp-link" href="'+r.coa+'" target="_blank" rel="noopener" title="View Certificate of Analysis">'+label+' ↗</a>'
          : '<span title="0 of 6 polymers detected &middot; LOD 1 microparticle" style="background:#1D3D3E;color:#fff;font-size:10px;font-weight:700;padding:1px 6px;border-radius:3px">'+label+'</span>';
      }
      const assayCell=isMP?'<span style="background:rgba(29,61,62,0.1);color:#1D3D3E;font-size:10px;font-weight:600;padding:1px 6px;border-radius:3px">Microplastics</span>':'Fatty Acids';
      const rowStyle=isMP?' style="background:rgba(29,61,62,0.03)"':'';
      h+='<tr'+rowStyle+'><td><strong>'+r.s+'</strong></td><td style="color:var(--ce)">'+r.f+'</td><td>'+r.src+'</td><td>'+assayCell+'</td><td class="n">'+(r.n||'')+'</td><td>'+servTxt+'</td>'
        +'<td class="n">'+fmtCell(r.e)+'</td><td class="n">'+fmtCell(r.d)+'</td><td class="n">'+fmtCell(r.a)+'</td>'
        +'<td class="n" style="font-weight:700">'+fmtCell(r.t)+'</td><td class="n">'+mpCell+'</td></tr>';
    });
    h+='</tbody></table></div>';
    document.getElementById('om-table').innerHTML=h;
  }

  function renderRef(){
    let tt=0; P.forEach(p=>tt+=p.n);
    const mpTested=P.filter(p=>p.mp).length, coaCount=P.filter(p=>p.mpCoa).length;
    document.getElementById('om-ref').innerHTML=
      '<strong>'+P.length+'</strong> products &middot; <strong>'+tt+'</strong> lab samples &middot; <strong>'+mpTested+'</strong> microplastics-screened (0 of 6 polymers detected, LOD 1 microparticle) &middot; <strong>'+coaCount+'</strong> with published COA<br>'
      +'<strong>Reference.</strong> Omega values are product-level results from Seatopia’s third-party lab program, reported '
      +(basis==='100g'?'per 100 g edible portion':'per recommended serving (derived from the per-100 g value × serving size)')
      +'. Edacious values are the mean of n samples; Light Labs values are single-sample. Below-detection results are reported as such, never as zero.<br>'
      +'seatopianutritionresolved.csv &middot; last updated June 2, 2026<br>'
      +'microplasticsreference.csv (Light Labs / EMSL) &middot; last updated June 2, 2026<br>'
      +'nutrition_products.csv &middot; last updated June 2, 2026<br>'
      +'Microplastics: third-party lab tested; zero microplastics detected (0 of 6 polymers, LOD 1 microparticle) in the samples analyzed.';
  }

  function render(){renderChart();renderTable();renderRef();}

  window.omBasis=function(b,btn){basis=b;openIdx=-1;btn.parentElement.querySelectorAll('button').forEach(x=>x.classList.remove('active'));btn.classList.add('active');render();};
  window.omDet=function(i){document.querySelectorAll('.om-det.open').forEach(d=>d.classList.remove('open'));if(openIdx===i){openIdx=-1;return;}openIdx=i;var el=document.getElementById('om-d-'+i);if(el)el.classList.add('open');};
  window.omTab=function(v,btn){view=v;btn.parentElement.querySelectorAll('.om-tab').forEach(b=>b.classList.remove('active'));btn.classList.add('active');document.getElementById('om-chart').style.display=v==='chart'?'':'none';document.getElementById('om-table').style.display=v==='table'?'':'none';};
  window.omSort=function(k){if(sortK===k)sortA=!sortA;else{sortK=k;sortA=k==='s'||k==='f';}renderTable();};
  render();
})();

  } catch(e) { console.error(e); }
})();
})();
